import { render, staticRenderFns } from "./Scraper.vue?vue&type=template&id=0da6b4a4"
import script from "./Scraper.vue?vue&type=script&lang=js"
export * from "./Scraper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports